// extracted by mini-css-extract-plugin
export default {"menuBlock":"wF-z","title":"xF-z","nav":"yF-z","flexCell":"zF-z","facetLink":"AF-z"};